// extracted by mini-css-extract-plugin
export default {"timer":"W0-z","loaded":"X0-z"};